<template>
  <FormItem :label="label" prop="voices">
    <Tabs value="0" @on-click="index = $event">
      <TabPane v-for="(voice, index) in value" :name="`${index}`" :key="index" :label="getLabel(index)" >
        <form-item-voice :disabled="disabled" :formItemProps="formItemProps" :voice="voice" @change="value.splice(index, 1, $event)" :prop="`voices[${index}]`"/>
      </TabPane>
      <Button @click="addVoice" size="small" slot="extra" :disabled="disabled">增加语音</Button>
			<Button @click="$emit('openAi', index)" size="small" slot="extra" type="success" :disabled="disabled">文案优化</Button>
    </Tabs>
  </FormItem>
</template>

<script>
import FormItemVoice from './FormItemVoice.vue'
import { addNodeId } from '../utils/nodeIdPool';

export default {
  props: {
    value: {
      type: Array,
      default: () => []
    },
    label: {
      type: String,
      default: ''
    },
    formItemProps: {
      type: Object,
      default: () => ({})
    },
		disabled: {
      type: Boolean,
      default: false
    }
  },
	data() {
		return {
			index: 0,
		}
	},
  components: { FormItemVoice },
  methods: {
		// 添加语音
		addVoice() {
			this.value.push({ id: addNodeId('V'), text: '', voice: '' })
		},
		// 删除语音
		delVoice(index) {
			this.value.splice(index, 1);
			// 如果是最后一个，则新加一下
			if (this.value.length === 0) {
				this.addVoice();
			}
		},
		getLabel(index) {
			return (h) => h(
				'div', [
					h('span', `语音${index + 1}`),
					h('Icon', {
						style: {
							marginLeft: '5px',
							marginRight: 0,
							display: !this.disabled? 'inline' : 'none'
						},
						props: {
							type: 'md-close'
						},
						on: {
							click: () => {
								this.delVoice(index)
							}
						}
					})
				]
			)
		},
  }
}
</script>